



















































import { Component, Vue } from 'vue-property-decorator'
import { login } from '@/utils/http-client/auth-api'
import { getDesigner } from '@/utils/http-client/designer-api'
import MessageBus from '@/utils/buses/MessageBus'
import { requiredValidation } from '@/utils/validations'

@Component
export default class Login extends Vue {
  private email: string = ''
  private password: string = ''
  private showPassword: boolean = false
  private isSubmitting: boolean = false
  private rules = {
    required: requiredValidation
  }

  private async onSubmit () {
    if (!(this.$refs.form as Vue & { validate: () => boolean}).validate()) {
      MessageBus.sendFormError()
      return
    }
    this.isSubmitting = true

    try {
      const user = await login(this.email, this.password)

      // if user is designer, navigate to their page
      if (user.designer_id) {
        const res = await getDesigner(user.designer_id)

        this.$router.push({
          name: 'designer',
          params: {
            name: res.designer.name,
            id: res.designer.id
          }
        })
      } else {
        // else navigate to home page
        this.$router.push({
          name: 'designers'
        })
      }
    } catch (err) {
      switch (err.status) {
        case 401:
          MessageBus.sendMessage('Invalid Credentials', 'error')
          break
        default:
          console.error('login Error:', err)
          MessageBus.sendDefaultError()
      }
    } finally {
      this.isSubmitting = false
    }
  }
}
